import { Switch as AntdSwitch } from "@empglabs/backoffice-ui-kit"

const Switch = props => {
  return <AntdSwitch {...props} />
}

export default Switch
